export default "/build/images/logo-arabic-1024x298.png?5d0c990d97f1559be48f3c24e5c9a0bf";